import React from 'react';
import { Avatar, Box, Skeleton, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

import { IconButtonStyledOutlined } from '@/components/common/iconButtonStyledOutlined';
import { getPhotoUrl } from '@/utils/getPhotoUrl';
import { ContactBase as Contact } from '@/store/contactsApi';

interface TeamMemberPreviewProps {
  member: Contact;
  isLoading: boolean;
}

export const TeamMemberPreview: React.FC<TeamMemberPreviewProps> = ({
  member,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        gap={2}
        padding={3}
      >
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
        >
          <Skeleton
            variant='circular'
            height={100}
            width={100}
          />

          <Box
            display='flex'
            flexDirection='column'
            alignItems='center'
            textAlign='center'
            sx={{ marginTop: 1 }}
          >
            <Skeleton
              variant='text'
              width={90}
              height={40}
            />

            <Skeleton
              variant='text'
              width={150}
              height={32}
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Skeleton height={64}>
            <IconButtonStyledOutlined variant='outlined'>
              <EmailIcon />
            </IconButtonStyledOutlined>
          </Skeleton>
          <Skeleton>
            <IconButtonStyledOutlined variant='outlined'>
              <LocalPhoneIcon />
            </IconButtonStyledOutlined>
          </Skeleton>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      gap={2}
      padding={3}
    >
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
      >
        <Avatar
          src={getPhotoUrl(member.Photo) ?? ''}
          alt={member.FullName}
          style={{
            width: 100,
            height: 100,
            objectFit: 'cover',
            borderRadius: 50,
          }}
        />
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          textAlign='center'
          sx={{ marginTop: 1 }}
        >
          <Typography variant='h6'>{member.FullName}</Typography>
          <Typography variant='body2'>{member.Title}</Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <a
          href={`mailto:${member.EmailAddress}`}
          style={{ textDecoration: 'none' }}
        >
          <IconButtonStyledOutlined variant='outlined'>
            <EmailIcon />
          </IconButtonStyledOutlined>
        </a>
        <a
          href={`tel:${member.Work || member.Mobile}`}
          style={{ textDecoration: 'none' }}
          onClick={(e) => {
            if (!member.Work && !member.Mobile) {
              e.preventDefault();
            }
          }}
        >
          <IconButtonStyledOutlined
            variant='outlined'
            sx={{
              opacity: !member.Work && !member.Mobile ? 0.5 : 1,
            }}
          >
            <LocalPhoneIcon />
          </IconButtonStyledOutlined>
        </a>
      </Box>
    </Box>
  );
};
